import styled from 'styled-components';
import ExtraInfoSection from './ExtraInfoSection';

export default styled(ExtraInfoSection)`
  flex-grow: 1;
  > div > div {
    width: 100% !important;
  }
  .extra-info {
    &__title {
      font-size: 1.2rem;
      font-weight: bold;
      text-transform: uppercase;
      color: var(--grey500);
    }
  }
`;
